import styled from "styled-components";

export const Span = styled.span`
  color: ${({ theme }) => `${theme.colors.gray}`};
`;

export const Title = styled.h1`
  margin-top: 0;
`;
